var account_events = (function( $ ) {

	var $events;

	var _init = function() {
		$events = $( '#my-events' );

		if ( $events.length > 0 ) {
			_maybe_change_tab();
		}
	};

	var _maybe_change_tab = function() {
		if ( window.location.hash && window.location.hash !== '#!' ) {
			$( 'a[href=' + window.location.hash + ']' ).click();
		}
	};

	// $( document ).ready( _init );

	return {};

})( jQuery );

module.exports = account_events;